"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeFieldTextStyles = void 0;

var _constants = require("./components/constants");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _designLanguage = require("@doordash/design-language");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getThemeFieldTextStyles = function getThemeFieldTextStyles(_ref) {
  var theme = _ref.theme,
      size = _ref.size,
      styleType = _ref.styleType;
  var densityString = "".concat((0, _lodash["default"])(theme, 'Typography.Density'), "Density");
  var textStylesDef = (0, _lodash["default"])(theme, "Typography.TextStyles.".concat(_constants.SizeSemantics[size]).concat(styleType));
  var mobileStyles = (0, _designLanguage.getThemeTextStyleValues)({
    completeSemanticDefinition: textStylesDef,
    themeDensityString: densityString
  });
  var desktopStyles = (0, _designLanguage.getThemeTextStyleValues)({
    completeSemanticDefinition: textStylesDef,
    themeDensityString: densityString,
    includeDesktopOverrides: true
  });
  return {
    mobile: mobileStyles,
    desktop: desktopStyles
  };
};

exports.getThemeFieldTextStyles = getThemeFieldTextStyles;